
var id = "coupon";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 90 90\" id=\"coupon\">\n<path d=\"M54.9,5.2c-1.6-1.6-4.1-1.6-5.7,0l-44,44c-1.6,1.6-1.6,4.1,0,5.7l5.6,5.6c5.4-2.6,11.8-1.5,16,2.8c4.2,4.2,5.3,10.6,2.8,16\n\tl5.6,5.6c1.6,1.6,4.1,1.6,5.7,0l44-44c1.6-1.6,1.6-4.1,0-5.7l-4.2-4.2c-5.6,3.4-12.7,2.5-17.3-2.1S57.8,17,61.2,11.5\n\tC61.2,11.5,54.9,5.2,54.9,5.2z M87.6,32.2c3.1,3.2,3.1,8.2,0,11.4l-44,44c-3.2,3.1-8.2,3.1-11.4,0l-7.8-7.8c3.5-4,3.2-10-0.5-13.7\n\tc-3.7-3.7-9.7-4-13.7-0.5l-7.8-7.8c-3.1-3.2-3.1-8.2,0-11.4l44-44c3.2-3.1,8.2-3.1,11.4,0l8.9,8.9c-2.8,2.5-4.1,6.3-3.2,10\n\tc0.9,3.7,3.8,6.5,7.4,7.4c3.7,0.9,7.5-0.3,10-3.2C80.8,25.4,87.6,32.2,87.6,32.2z M46.6,29.5L29.5,46.6c-0.8,0.8-0.8,2,0,2.8\n\tc0.8,0.8,2,0.8,2.8,0l17.1-17.1c0.8-0.8,0.8-2,0-2.8C48.6,28.7,47.4,28.7,46.6,29.5z M57.7,41.6L41.6,57.7c-0.8,0.8-0.8,2,0,2.8\n\ts2,0.8,2.8,0l16.1-16.1c0.8-0.8,0.8-2,0-2.8C59.7,40.8,58.5,40.8,57.7,41.6z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
